import { render, staticRenderFns } from "./HookWebToppings.vue?vue&type=template&id=3127ae10&scoped=true&"
import script from "./HookWebToppings.vue?vue&type=script&lang=js&"
export * from "./HookWebToppings.vue?vue&type=script&lang=js&"
import style0 from "./HookWebToppings.vue?vue&type=style&index=0&id=3127ae10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127ae10",
  null
  
)

export default component.exports